// extracted by mini-css-extract-plugin
module.exports = {"link":"SubCategoryFilterItem_link__EC1wP","selected":"SubCategoryFilterItem_selected__Ezu50"};